import { Link, NavLink } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export default function Header() {
  const { user, game, logout } = useAuth()

  return (
    <header className="header">
      <Link to="/" className="brand">
        <span className="brand-mark" aria-hidden="true">
          🗼
        </span>
        <span className="brand-text">
          Stack School
          <small>learn the stack by being the stack</small>
        </span>
      </Link>

      <nav className="nav">
        <NavLink to="/" end>
          Tower
        </NavLink>
        {user && <NavLink to="/dashboard">Dashboard</NavLink>}
        {user && <NavLink to="/patrol">Patrol</NavLink>}
        <NavLink to="/collection">Collection</NavLink>
      </nav>

      {user && game ? (
        <div className="hud">
          <div className="hud-stat" title={`${game.totalXp} XP total`}>
            <span className="hud-label">LVL</span>
            <span className="hud-value">{game.level}</span>
            <div className="xp-bar" aria-hidden="true">
              <div className="xp-fill" style={{ width: `${Math.round(game.progress * 100)}%` }} />
            </div>
          </div>
          <div className="hud-stat" title="Day streak">
            <span className="hud-value">🔥 {game.streak}</span>
          </div>
          <div className="hud-stat" title="Gems">
            <span className="hud-value">💎 {game.gems}</span>
          </div>
          <div className="hud-user">
            <Link to="/account">{user.displayName ?? user.email.split('@')[0]}</Link>
            {user.role !== 'student' && <span className="role-badge">{user.role}</span>}
            <button type="button" className="link-button" onClick={() => void logout()}>
              Sign out
            </button>
          </div>
        </div>
      ) : (
        <Link to="/login" className="button button-primary">
          Sign in
        </Link>
      )}
    </header>
  )
}
